import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "img-wall container"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "opt-box"
};
const _hoisted_4 = {
  class: "opt-box"
};
const _hoisted_5 = {
  class: "opt-box"
};
const _hoisted_6 = ["data-clipboard-text"];
import { onMounted, onUnmounted, ref } from "vue";
import { httpGet } from "@/utils/http";
import { showConfirmDialog, showFailToast, showImagePreview, showNotify } from "vant";
import Clipboard from "clipboard";
import { ElMessage } from "element-plus";
export default {
  __name: 'ImgWall',
  setup(__props) {
    const activeName = ref("mj");
    const data = ref({
      "mj": {
        loading: false,
        finished: false,
        error: false,
        page: 1,
        pageSize: 12,
        url: "/mj/imgWall",
        data: []
      },
      "sd": {
        loading: false,
        finished: false,
        error: false,
        page: 1,
        pageSize: 12,
        url: "/sd/imgWall",
        data: []
      },
      "dall": {
        loading: false,
        finished: false,
        error: false,
        page: 1,
        pageSize: 12,
        url: "/dall/imgWall",
        data: []
      }
    });
    const prompt = ref('');
    const clipboard = ref(null);
    onMounted(() => {
      clipboard.value = new Clipboard(".copy-prompt-wall");
      clipboard.value.on('success', () => {
        showNotify({
          type: 'success',
          message: '复制成功',
          duration: 1000
        });
      });
      clipboard.value.on('error', () => {
        showNotify({
          type: 'danger',
          message: '复制失败',
          duration: 2000
        });
      });
      clipboard.value.on('error', () => {
        ElMessage.error('复制失败！');
      });
    });
    onUnmounted(() => {
      clipboard.value.destroy();
    });
    const onLoad = () => {
      const d = data.value[activeName.value];
      httpGet(`${d.url}?status=1&page=${d.page}&page_size=${d.pageSize}&publish=true`).then(res => {
        d.loading = false;
        if (res.data.items.length === 0) {
          d.finished = true;
          return;
        }

        // 生成缩略图
        const imageList = res.data.items;
        for (let i = 0; i < imageList.length; i++) {
          imageList[i]["img_thumb"] = imageList[i]["img_url"] + "?imageView2/4/w/300/h/0/q/75";
        }
        if (imageList.length < d.pageSize) {
          d.finished = true;
        }
        if (d.data.length === 0) {
          d.data = imageList;
        } else {
          d.data = d.data.concat(imageList);
        }
        d.page += 1;
      }).catch(() => {
        d.error = true;
        showFailToast("加载图片数据失败");
      });
    };
    const showPrompt = item => {
      prompt.value = item.prompt;
      showConfirmDialog({
        title: "绘画提示词",
        message: item.prompt,
        confirmButtonText: "复制",
        cancelButtonText: "关闭"
      }).then(() => {
        document.querySelector('#copy-btn-wall').click();
      }).catch(() => {});
    };
    const imageView = item => {
      showImagePreview([item['img_url']]);
    };
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_el_button = _resolveComponent("el-button");
      const _component_van_cell = _resolveComponent("van-cell");
      const _component_van_list = _resolveComponent("van-list");
      const _component_van_tab = _resolveComponent("van-tab");
      const _component_van_tabs = _resolveComponent("van-tabs");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_tabs, {
        active: activeName.value,
        "onUpdate:active": _cache[6] || (_cache[6] = $event => activeName.value = $event),
        animated: "",
        sticky: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_van_tab, {
          title: "MJ",
          name: "mj"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_list, {
            error: data.value['mj'].error,
            "onUpdate:error": _cache[0] || (_cache[0] = $event => data.value['mj'].error = $event),
            loading: data.value['mj'].loading,
            "onUpdate:loading": _cache[1] || (_cache[1] = $event => data.value['mj'].loading = $event),
            finished: data.value['mj'].finished,
            "error-text": "请求失败，点击重新加载",
            "finished-text": "没有更多了",
            onLoad: onLoad,
            style: {
              "height": "100%",
              "width": "100%"
            }
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value['mj'].data, item => {
              return _openBlock(), _createBlock(_component_van_cell, {
                key: item.id
              }, {
                default: _withCtx(() => [_createVNode(_component_van_image, {
                  src: item['img_thumb'],
                  onClick: $event => imageView(item),
                  fit: "cover"
                }, null, 8, ["src", "onClick"]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
                  type: "primary",
                  onClick: $event => showPrompt(item),
                  circle: ""
                }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [_createElementVNode("i", {
                    class: "iconfont icon-prompt"
                  }, null, -1)])),
                  _: 2
                }, 1032, ["onClick"])])]),
                _: 2
              }, 1024);
            }), 128))]),
            _: 1
          }, 8, ["error", "loading", "finished"])]),
          _: 1
        }), _createVNode(_component_van_tab, {
          title: "SD",
          name: "sd"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_list, {
            error: data.value['sd'].error,
            "onUpdate:error": _cache[2] || (_cache[2] = $event => data.value['sd'].error = $event),
            loading: data.value['sd'].loading,
            "onUpdate:loading": _cache[3] || (_cache[3] = $event => data.value['sd'].loading = $event),
            finished: data.value['sd'].finished,
            "error-text": "请求失败，点击重新加载",
            "finished-text": "没有更多了",
            onLoad: onLoad
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value['sd'].data, item => {
              return _openBlock(), _createBlock(_component_van_cell, {
                key: item.id
              }, {
                default: _withCtx(() => [_createVNode(_component_van_image, {
                  src: item['img_thumb'],
                  onClick: $event => imageView(item),
                  fit: "cover"
                }, null, 8, ["src", "onClick"]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
                  type: "primary",
                  onClick: $event => showPrompt(item),
                  circle: ""
                }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [_createElementVNode("i", {
                    class: "iconfont icon-prompt"
                  }, null, -1)])),
                  _: 2
                }, 1032, ["onClick"])])]),
                _: 2
              }, 1024);
            }), 128))]),
            _: 1
          }, 8, ["error", "loading", "finished"])]),
          _: 1
        }), _createVNode(_component_van_tab, {
          title: "DALL",
          name: "dall"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_list, {
            error: data.value['dall'].error,
            "onUpdate:error": _cache[4] || (_cache[4] = $event => data.value['dall'].error = $event),
            loading: data.value['dall'].loading,
            "onUpdate:loading": _cache[5] || (_cache[5] = $event => data.value['dall'].loading = $event),
            finished: data.value['dall'].finished,
            "error-text": "请求失败，点击重新加载",
            "finished-text": "没有更多了",
            onLoad: onLoad
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value['dall'].data, item => {
              return _openBlock(), _createBlock(_component_van_cell, {
                key: item.id
              }, {
                default: _withCtx(() => [_createVNode(_component_van_image, {
                  src: item['img_thumb'],
                  onClick: $event => imageView(item),
                  fit: "cover"
                }, null, 8, ["src", "onClick"]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
                  type: "primary",
                  onClick: $event => showPrompt(item),
                  circle: ""
                }, {
                  default: _withCtx(() => _cache[9] || (_cache[9] = [_createElementVNode("i", {
                    class: "iconfont icon-prompt"
                  }, null, -1)])),
                  _: 2
                }, 1032, ["onClick"])])]),
                _: 2
              }, 1024);
            }), 128))]),
            _: 1
          }, 8, ["error", "loading", "finished"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["active"])]), _createElementVNode("button", {
        style: {
          "display": "none"
        },
        class: "copy-prompt-wall",
        "data-clipboard-text": prompt.value,
        id: "copy-btn-wall"
      }, "复制 ", 8, _hoisted_6)]);
    };
  }
};